let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1t7P4")).then(() => parcelRequire('5PH0x'));